import { Alert, Button, Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    fullName: string,
    onConfirm: () => void
    onCancel: () => void
}

const RuleOutModal = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Rule-Out Donor Candidate</Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: 20, textAlign: 'center' }}>
                    Confirm that you want to rule-out donor <strong>{props.fullName}</strong>...
                </div>

                <Alert bsStyle='danger' bsSize='sm'>
                    This will rule out the donor, set their Pre-Workup Lab status to 'Incomplete', and cancel all jug orders. Jug shipments already requested 
                    will not be cancelled, but the donor will NOT receive an email when they receive the jug...possibly creating some confusion since the 
                    insert with the jug will tell them to watch for the email.
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirm</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default RuleOutModal;